import { Button, Dropdown, Menu } from "antd";
import React, { FC } from "react";

import { GlobalOutlined } from "@ant-design/icons";
import Image from "next/image";
import Link from "next/link";
import it from "@public/flags/italy.png";
import styles from "./LanguageSwitcher.module.scss";
import usa from "@public/flags/usa.png";
import { useRouter } from "next/router";

interface LanguageSwitcherProps {
  className?: string;
}

const LanguageSwitcher: FC<LanguageSwitcherProps> = ({ className }) => {
  const { asPath, locale, locales } = useRouter();

  return (
    <Dropdown
      arrow
      placement="top"
      destroyPopupOnHide
      overlayClassName={styles.Overlay}
      overlay={
        <Menu activeKey={locale}>
          {locales.map((l) => (
            <Menu.Item key={l} title={null}>
              <Link passHref href={asPath} locale={l}>
                <a title={l}>
                  <Image
                    alt={l}
                    width={24}
                    height={24}
                    src={l === "it" ? it : usa}
                  />
                </a>
              </Link>
            </Menu.Item>
          ))}
        </Menu>
      }
    >
      <Button shape="circle" className={className} icon={<GlobalOutlined />} />
    </Dropdown>
  );
};

export default LanguageSwitcher;
